<template>
    <div>
        <page-header title="ساخت دسته بندی جدید"></page-header>

        <crud-generator :fields="fields" @submit="submit" name="categories"></crud-generator>

        <v-card class="settings-card">
            <v-card-title>
                <v-icon left>mdi-map-marker-multiple</v-icon>نقطه گذاری تصویر
                <v-spacer></v-spacer>
                <v-btn class="btn-secondary" outlined @click="hotspot = !hotspot">
                    <v-icon left>{{ hotspot ? 'mdi-close' : 'mdi-pencil' }}</v-icon>
                    {{ hotspot ? 'بستن' : 'ویرایش نقاط' }}
                </v-btn>
            </v-card-title>
            <v-card-text v-if="hotspot" class="hotspot-container">
                <image-hotspot class="image-hotspot" @pointsUpdated="(items) => points = items"
                               @imageUploaded="(img) => pointsImg = img"></image-hotspot>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";
export default {
    name: "CreateCategory",

    components: {CrudGenerator, PageHeader},

    data() {
        return {
            hotspot: false,
            points: [],
            pointsImg: null,
            fields: [],
            allCategories: null,
        }
    },

    mounted() {
        this.getAllCategories()
    },

    methods: {
        getAllCategories() {
            this.$store.dispatch("getAllCategories")
                .then((res) => {
                    this.allCategories = res.data
                    this.fillFields()
                })
        },

        fillFields() {
            this.fields = [
                {
                    name: 'fa_name',
                    label: 'نام',
                    cols: 6,
                    type: 'text',
                    direction: 'rtl',
                },
                {
                    name: 'fa_subtitle',
                    label: 'زیرعنوان',
                    cols: 6,
                    type: 'text',
                    direction: 'rtl',
                },
                {
                    name: 'fa_short_description',
                    label: 'توضیح کوتاه',
                    cols: 12,
                    type: 'text',
                    direction: 'rtl'
                },
                {
                    name: 'fa_description',
                    label: 'توضیحات',
                    cols: 12,
                    type: 'ckeditor',
                    direction: 'rtl'
                },
                {
                    name: 'fa_meta_title',
                    label: 'عنوان متا',
                    cols: 6,
                    type: 'text',
                    direction: 'rtl'
                },
                {
                    name: 'fa_meta_keywords',
                    label: 'کلیدواژه های متا',
                    cols: 6,
                    type: 'text',
                    direction: 'rtl'
                },
                {
                    name: 'fa_meta_descriptions',
                    label: 'توضیحات متا',
                    cols: 12,
                    type: 'text',
                    direction: 'rtl'
                },

                {
                    name: 'en_name',
                    label: 'Name',
                    cols: 6,
                    type: 'text',
                    direction: 'ltr',
                },
                {
                    name: 'en_subtitle',
                    label: 'Subtitle',
                    cols: 6,
                    type: 'text',
                    direction: 'ltr',
                },
                {
                    name: 'en_short_description',
                    label: 'Short Description',
                    cols: 12,
                    type: 'text',
                    direction: 'ltr'
                },
                {
                    name: 'en_description',
                    label: 'Description',
                    cols: 12,
                    type: 'text',
                    direction: 'ltr'
                },
                {
                    name: 'en_meta_title',
                    label: 'Meta Title',
                    cols: 6,
                    type: 'text',
                    direction: 'ltr'
                },
                {
                    name: 'en_meta_keywords',
                    label: 'Meta Keywords',
                    cols: 6,
                    type: 'text',
                    direction: 'ltr'
                },
                {
                    name: 'en_meta_descriptions',
                    label: 'Meta Description',
                    cols: 12,
                    type: 'text',
                    direction: 'ltr'
                },

                {
                    name: 'parent_category_id',
                    label: 'دسته بندی والد',
                    cols: 6,
                    type: 'select',
                    select_items: this.allCategories,
                    select_value: 'id',
                    select_text: 'fa_name',
                },
                {
                    name: 'image',
                    label: 'تصویر',
                    cols: 6,
                    type: 'image',
                },
            ]
        },

        submit(values) {
            this.$store.dispatch("createCategory", {
                ...values,
                ...{hotspot_points: this.points, hotspot_image: this.pointsImg},
            })
                .then(() => {
                    this.$router.push('/categories')
                })
        },
    }
}
</script>

<style scoped>
.hotspot-container {
    justify-content: center;
    display: flex
}

.image-hotspot {
    width: 85%;
    justify-self: center
}
</style>